import { EventEmitter, Injectable } from '@angular/core';
import { MapPosition } from '../models/map-position.model';
import { MapsAPILoader } from '@agm/core';

//declare var google: any;

@Injectable()
export class MapService {
  public userLocation = new EventEmitter<Position>();
  public toggleMap = new EventEmitter<boolean>();
  private userPosition: Promise<MapPosition>;
  private latestPosition: MapPosition;
  private defaultPosition: MapPosition = {
    lat: 39.8282,
    lng: -98.5795,
    fitBoundsLiteral: {
      south: 25.82,
      west: -124.39,
      north: 49.38,
      east: -66.94
    }
  };

  constructor(
    private mapsAPILoader: MapsAPILoader,
  ) {
    this.mapsAPILoader.load()
      .then(() => {
        const sw = {
          lat: this.defaultPosition.fitBoundsLiteral.south,
          lng: this.defaultPosition.fitBoundsLiteral.west
        },
          ne = {
            lat: this.defaultPosition.fitBoundsLiteral.north,
            lng: this.defaultPosition.fitBoundsLiteral.east
          };

        this.defaultPosition.fitBounds = new google.maps.LatLngBounds(sw, ne);
      });
  }

  public getDefaultPosition(): MapPosition {
    return this.defaultPosition;
  }

  public getGeoLocationPosition(): Promise<MapPosition> {
    if (!this.userPosition) {
      this.userPosition = new Promise((resolve, reject) => {
        if ('geolocation' in navigator) {
          navigator.geolocation.getCurrentPosition((position) => {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
              zoom: 15 // TODO improve it
            });
          });

          navigator.geolocation.watchPosition((position) => {
            this.userLocation.emit(position);
          });

        } else {
          reject('Geolocation not available');
        }
      });

      this.userPosition
        .then((position: MapPosition) => this.latestPosition = position);
    }

    return this.userPosition;
  }

  public getLatestPosition(): MapPosition {
    if (this.latestPosition) {
      return this.latestPosition;
    } else {
      return this.defaultPosition;
    }
  }

  unlockMap() {
    this.toggleMap.emit(true);
  }

  lockMap() {
    this.toggleMap.emit(false);
  }
}
